import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { MinimalHeader } from './MinimalHeader';
import { Footer } from './Footer';
import { CookieConsent } from '@/components/CookieConsent';
import { t, type MessageKey } from '@/i18n';
import { NAIC_CHECKLIST_ROUTE } from '@/pages/lighthouse/naicChecklistLinks';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Routes rendered without the site chrome: logo-only header, no footer.
 * Each entry says where its logo should link and what tag to show beside it.
 */
const STANDALONE_ROUTES: Record<string, { homeTo: string; tag: MessageKey }> = {
  [NAIC_CHECKLIST_ROUTE]: { homeTo: '/lighthouse', tag: 'lighthouse.checklist.header.tag' },
};

export function Layout({ children }: LayoutProps) {
  const { pathname } = useLocation();
  const standalone = STANDALONE_ROUTES[pathname.replace(/\/$/, '')];

  return (
    <div className="flex min-h-screen flex-col">
      {standalone ? (
        <MinimalHeader homeTo={standalone.homeTo} tag={t(standalone.tag)} />
      ) : (
        <Header />
      )}
      <main className="flex-1">{children}</main>
      {!standalone && <Footer />}
      <CookieConsent />
    </div>
  );
}
